module.exports = __webpack_public_path__ + "img/banner1.917eb123.jpg";